import React from "react";
import Header from "../../Components/Header";
import Footer from "./Footer"
import BandDisplay from "./brand";
import Slider from "./slider";
import Services from "./services";
import FlowChartRender from "./flowchartrender";
import ProductSection from "./productshower";
import AboutUs from "./About";
import ProductFlowChart from './flowChart';
import FocusIndustries from './workIndustries'
const Home = () => {
  return (
    <div>
      {/* <div className="promotion-box">
        <div className="container-fluid">
          <p className="promotion-text">
            Free Shipping on all orders over $100!
            <a className="link" href="#">
              Shop Now
            </a>
          </p>
          <span className="promotion-close">
            <i className="ti-close" />
          </span>
        </div>
      </div> */}
      
      <div >
        <Header />
        <Slider />
        <AboutUs />
        <Services />
        <FocusIndustries/>
        <ProductSection />
        <BandDisplay />
        <ProductFlowChart />
        <Footer />
      </div>
      
    </div>
  );
};

export default Home;
